/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { createTheme, type MantineTheme } from '@mantine/core';

import { colorToken, typographyToken, variablesToken } from '@fai/design-tokens';

const shadowTheme = (() => {
  const { effect } = variablesToken;
  const shadowLg = effect['shadow-lg'],
    shadowMd = effect['shadow-md'],
    shadowSm = effect['shadow-sm'],
    shadowSmLighter = effect['shadow-sm-lighter'],
    toastShadow = effect['toast-shadow'],
    toggleShadowLeft = effect['toggle-shadow-left'],
    toggleShadowRight = effect['toggle-shadow-right'];

  return {
    'shadow-lg': `${shadowLg.offsetX}px ${shadowLg.offsetY}px ${shadowLg.radius}px ${shadowLg.spread}px ${shadowLg.color}`,
    'shadow-md': `${shadowMd.offsetX}px ${shadowMd.offsetY}px ${shadowMd.radius}px ${shadowMd.spread}px ${shadowMd.color}`,
    'shadow-sm': `${shadowSm.offsetX}px ${shadowSm.offsetY}px ${shadowSm.radius}px ${shadowSm.spread}px ${shadowSm.color}`,
    'shadow-sm-lighter': `${shadowSmLighter.offsetX}px ${shadowSmLighter.offsetY}px ${shadowSmLighter.radius}px ${shadowSmLighter.spread}px ${shadowSmLighter.color}`,
    'toast-shadow': `${toastShadow.offsetX}px ${toastShadow.offsetY}px ${toastShadow.radius}px ${toastShadow.spread}px ${toastShadow.color}`,
    'toggle-shadow-left': `${toggleShadowLeft.offsetX}px ${toggleShadowLeft.offsetY}px ${toggleShadowLeft.radius}px ${toggleShadowLeft.spread}px ${toggleShadowLeft.color}`,
    'toggle-shadow-right': `${toggleShadowRight.offsetX}px ${toggleShadowRight.offsetY}px ${toggleShadowRight.radius}px ${toggleShadowRight.spread}px ${toggleShadowRight.color}`,
  };
})();

export const pfTheme = createTheme({
  pf: {
    color: {
      bg: colorToken.color.bg,
      fg: colorToken.color.fg,
      border: colorToken.color.border,
    },
    typography: {
      saans: {
        '2xl': typographyToken.saans['typography-saans-2xl'],
        xl: typographyToken.saans['typography-saans-xl'],
        lg: typographyToken.saans['typography-saans-lg'],
        md: typographyToken.saans['typography-saans-md'],
        sm: typographyToken.saans['typography-saans-sm'],
        xs: typographyToken.saans['typography-saans-xs'],
      },
      title: {
        xl: typographyToken.title['typography-title-xl'],
        lg: typographyToken.title['typography-title-lg'],
        md: typographyToken.title['typography-title-md'],
        sm: typographyToken.title['typography-title-sm'],
        xs: typographyToken.title['typography-title-xs'],
        '2xs': typographyToken.title['typography-title-2xs'],
      },
      body: {
        lg: typographyToken.body['typography-body-lg'],
        md: typographyToken.body['typography-body-md'],
        sm: typographyToken.body['typography-body-sm'],
        xs: typographyToken.body['typography-body-xs'],
      },
      mono: {
        lg: typographyToken.mono['typography-mono-lg'],
        md: typographyToken.mono['typography-mono-md'],
        sm: typographyToken.mono['typography-mono-sm'],
        xs: typographyToken.mono['typography-mono-xs'],
      },
    },
    radius: variablesToken.radius,
    layout: variablesToken.layout,
    shadow: shadowTheme,
  },
}) as MantineTheme;
